(function () {
  'use strict';

  var page = document.querySelector('[data-policy-page]');
  var nativeContainer = document.querySelector('.shopify-policy__container');
  if (!page || !nativeContainer) return;
  var content = nativeContainer.querySelector('.shopify-policy__body') || nativeContainer;
  var nativeTitle = nativeContainer.querySelector('.shopify-policy__title');
  var list = page.querySelector('[data-policy-toc]');
  var wrap = page.querySelector('[data-policy-toc-wrap]');
  var slot = page.querySelector('[data-policy-slot]');
  if (!content || !list || !wrap || !slot) return;

  if (nativeTitle) nativeTitle.remove();

  var administrativeName = page.dataset.policyShopName;
  var legalName = page.dataset.policyLegalName;
  if (administrativeName && legalName && administrativeName !== legalName) {
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (textNode.nodeValue.indexOf(administrativeName) !== -1) {
        textNode.nodeValue = textNode.nodeValue.split(administrativeName).join(legalName);
      }
    }
  }

  nativeContainer.classList.add('policy-content');
  slot.replaceWith(nativeContainer);

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
  headings.forEach(function (heading, index) {
    if (!heading.id) heading.id = 'politica-secao-' + (index + 1);
    var item = document.createElement('li');
    if (heading.tagName === 'H3') item.className = 'policy-toc__subitem';
    var link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();
    item.appendChild(link);
    list.appendChild(item);
  });
  wrap.hidden = headings.length < 2;
})();
